import { render, staticRenderFns } from "./edit_product_group_sp.vue?vue&type=template&id=0cd44dce&scoped=true&"
import script from "./edit_product_group_sp.vue?vue&type=script&lang=js&"
export * from "./edit_product_group_sp.vue?vue&type=script&lang=js&"
import style0 from "./edit_product_group_sp.vue?vue&type=style&index=0&id=0cd44dce&prod&lang=scss&"
import style1 from "./edit_product_group_sp.vue?vue&type=style&index=1&id=0cd44dce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd44dce",
  null
  
)

export default component.exports